import { render, staticRenderFns } from "./practitionerprofile.vue?vue&type=template&id=e8a0c35e&scoped=true"
import script from "./practitionerprofile.vue?vue&type=script&lang=js"
export * from "./practitionerprofile.vue?vue&type=script&lang=js"
import style0 from "./practitionerprofile.vue?vue&type=style&index=0&id=e8a0c35e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8a0c35e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VCard,VChip,VCol,VIcon,VRow,VSpacer})
